import React from 'react';

import './home-header.css';
import profileImg from '../../../assets/images/profile.png';

const HomeHeader = () => {
  return (
    <div className='home-header'>
      <div className='header-titles'>
        <h1>Dor Moshe</h1>
        <h2>Full-Stack Web Developer</h2>
      </div>

      <div className='profile-image-container'>
        <div className='profile-image'>
          <img src={profileImg} height='222' width='222' alt='dor moshe' />
        </div>
      </div>
    </div>
  );
};

export default HomeHeader;